import { Map } from "ol";
import React from "react";
import { useProjectDetails } from "../hooks/useProjectDetails";
import { PoiItemAddContent } from "./PoiItemAddContent";
import { PoiItemTable } from "./PoiItemTable";

export enum PoiItemScreenEnum {
  PoiList = 1,
  PoiAdd = 2,
}

export type PoiItemsContainerProps = {
  map: Map | undefined;
  setDrawModeEnabled: React.Dispatch<React.SetStateAction<boolean>>;
};

export const PoiItemsContainer = ({
  map,
  setDrawModeEnabled,
}: PoiItemsContainerProps) => {
  const { id } = useProjectDetails();

  const [activeScreen, setActiveScreen] = React.useState<PoiItemScreenEnum>(
    PoiItemScreenEnum.PoiList,
  );

  React.useEffect(() => {
    if (activeScreen === PoiItemScreenEnum.PoiAdd) setDrawModeEnabled(true);
    else setDrawModeEnabled(false);
  }, [activeScreen, setDrawModeEnabled]);

  const activeContent = React.useMemo(() => {
    switch (activeScreen) {
      case PoiItemScreenEnum.PoiList:
        return (
          <PoiItemTable map={map} setActiveScreen={setActiveScreen} id={id} />
        );

      case PoiItemScreenEnum.PoiAdd:
        return (
          <PoiItemAddContent
            map={map}
            setActiveScreen={setActiveScreen}
            id={id}
          />
        );
      default:
        return null;
    }
  }, [activeScreen, id, map]);

  return <>{activeContent} </>;
};
